export default {
  props: {
    showValidation: { type: Boolean, default: true },
    rules: { type: [Array, String, Object], default: () => [] },
    chips: { type: Boolean, default: true },
    clearable: { type: Boolean, default: true },
    deletableChips: { type: Boolean, default: true },
    smallChips: { type: Boolean, default: true },
    outlined: { type: Boolean, default: true },
    shaped: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    dense: { type: Boolean, default: true },
    singleLine: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    counter: { type: Boolean, default: false },
    searchDebounceTime: { type: Number, default: 1500 },
    multiple: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: false },
    value: { type: [Number, Object, Array], default: null },
    queryParam: { type: String, default: "" },
    idPredicatePath: { type: String, default: "id" },
    itemValue: { type: String, default: "id" },
    preloadAllOptions: { type: Boolean, default: false },
    vid: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    selectedItemToText: { type: Function, default: () => "name" },
    listApi: { type: Function, default: () => [] },
    noFilter: { type: Boolean, default: true }
  }
};
